import type { OptimizerAuditV2Record } from '../../types/audit.types';

export const getMissingAuditPortfolioReportIds = (
  audits: OptimizerAuditV2Record[],
  reportsById: Map<string, unknown>,
): string[] => {
  const missingIds = new Set<string>();

  for (const audit of audits) {
    const reportId = audit.portfolioReportId;

    if (!reportId || reportsById.has(reportId)) {
      continue;
    }

    missingIds.add(reportId);
  }

  return [...missingIds];
};
